module.exports = __webpack_public_path__ + "static/media/gplay_store.9c82551d.webp";